import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { monthEndAlertConstants } from '../../actions/constant';
import monthEndAlertsService from '../../../services/apiServices/monthEndAlert/monthEndALerts';

const {
  REQUEST_CERTIFY_ALERT,
  SUCCESS_CERTIFY_ALERT,
  FAILURE_CERTIFY_ALERT,
  LOADING_CERTIFY_ALERT,
} = monthEndAlertConstants;

function* certifyAlert(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_CERTIFY_ALERT });
    const response = yield call(monthEndAlertsService.certifyMonthEndAlertCycle, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_CERTIFY_ALERT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_CERTIFY_ALERT, payload: error });
  }
}

function* certifyMonthEndAlertSaga() {
  yield takeEvery(REQUEST_CERTIFY_ALERT, certifyAlert);
}

export default certifyMonthEndAlertSaga;
